import styled from 'styled-components';
import Text from 'src/styles/Themes/Text';
import { cssVars } from '@/styles/Themes/cssVars';
import { radius, borders } from '@/styles/Themes/Metrics';
import Palette from '@/styles/Themes/Palette';
import { RedCross } from '@/shared/images/icons/RedCross';

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    height: 50px;
    width: 100%;
`;

export const Counter = styled.div`
    height: 46px;
    width: 120px;
    min-width: 120px;
    border-radius: 50px;
    border: 1px solid ${cssVars.bg_gray4_dark2};
    color: ${cssVars.fg_gray2_gray3};
    ${Text.Full.heading3}
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 8px;
`;

export const CommonContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    position: relative;
    width: fit-content;
`;

export const SelectTicketType = styled.span`
    ${Text.Mobile.normal.semibold};
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    background: ${cssVars.bg_lightBg_darkBg};
    border-radius: ${radius.small};
    border: ${borders.small} ${cssVars.bg_gray4_dark2};
    color: ${Palette.state.error};
    /*  height: 33px; */
    padding: 2px 2px 2px 14px;
    box-shadow: ${cssVars.shadow_card_default};
    /* width: 196px; */
    right: 0;
    left: 0;
    bottom: -26px;
    width: fit-content;
    max-width: 222px;
    text-wrap: nowrap;
    z-index: 1;

    &:before {
        content: '';
        height: 8px;
        width: 8px;
        border-bottom: ${borders.small} ${cssVars.bg_gray4_dark2};
        border-left: ${borders.small} ${cssVars.bg_gray4_dark2};
        background: ${cssVars.bg_lightBg_darkBg};
        border-right: none;
        border-top: none;
        transform: rotate(135deg);
        position: absolute;
        /* right: 112px; */
        top: -5px;
        left: 37px;
    }

    > span {
        z-index: 1;
        padding-right: 5px;
    }
`;

export const RedCrossIcon = styled(RedCross)``;
